import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';
import { NativeBridgeService } from '../../../core/services/native-bridge.service';

@Component({
  selector: 'app-native-session',
  templateUrl: './native-session.component.html',
  styleUrls: ['./native-session.component.scss'],
})
export class NativeSessionComponent implements OnInit {
  constructor(
    private router: Router,
    private authFackservice: AuthfakeauthenticationService,
    private nativeBridge: NativeBridgeService,
  ) {}

  private pendingRoute: string | null = null;

  ngOnInit(): void {
    if (!this.nativeBridge.isNative) {
      this.router.navigate(['/']);
      return;
    }

    this.nativeBridge
      .requestSession()
      .pipe(
        switchMap((session) => {
          this.pendingRoute = session?.pendingRoute || null;

          if (session?.currentUser?.refreshToken) {
            this.authFackservice.restoreSession(session.currentUser);
          }

          if (!this.authFackservice.hasRefreshToken()) {
            return of('guard');
          }

          return this.authFackservice
            .refreshSession()
            .pipe(catchError(() => of(null)));
        }),
      )
      .subscribe((resp: any) => {
        if (resp === 'guard' || resp?.token) {
          this.enter();
        } else {
          this.router.navigate(['/account/login-2'], {
            queryParams: this.pendingRoute ? { returnUrl: this.pendingRoute } : {},
          });
        }
      });
  }

  private enter(): void {
    if (this.pendingRoute) {
      this.router.navigateByUrl(this.pendingRoute).then((ok) => {
        if (!ok) this.router.navigate(['/']);
      });
      return;
    }

    this.router.navigate(['/']);
  }
}
